import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface AuthUser {
    displayName: string | null;
    uid: string;
    photoURL: string | null;
    email: string | null;
    emailVerified: boolean;
    phoneNumber: string | null;
}

const initialState: AuthUser = {
    displayName: null,
    uid: "",
    photoURL: null,
    email: null,
    emailVerified: false,
    phoneNumber: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        login (_state, action: PayloadAction<AuthUser>) {
            return {
                ...initialState,
                ...action.payload,
            };
        },
        logout () {
            return initialState;
        }
    },
})

export const {login, logout} = authSlice.actions;
export default authSlice.reducer;